/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
export const amountMandatory = (amount) => {
  const isInvalid = !amount && amount !== 0

  isInvalid && console.error('amount is mandatory')

  return isInvalid
}

export const currencies = Object.freeze({
  leos: 'leos',
  silverZetons: 'silverZetons',
  goldZetons: 'goldZetons',
  zetons: 'zetons'
})

export const valsForZetons = Object.freeze({
  leos: 1000000,
  milliZetons: 1000
})

export const currencyToZetons = (amount, currency) => {
  const isInvalid = amountMandatory(amount)

  if (isInvalid) return null

  const curCurrency = currencies[currency] || currencies.leos
  const exchangeValue = valsForZetons[curCurrency]

  return Number(amount / exchangeValue)
}

export const currencyFormat = (amount) => {
  const isInvalid = amountMandatory(amount)

  if (isInvalid) return null

  return Number(amount) > 0
    ? Number(amount).toLocaleString('en-US', {
      style: 'decimal',
      maximumFractionDigits: 3
    })
    : 0
}

export const currenciesSymbols = Object.freeze({
  leos: 'Leos',
  zetons: 'USD(ż)'
})

export const formLeosToZetons = (amount, withSymbol = true) => {
  const isInvalid = amountMandatory(amount)

  if (isInvalid) return null

  const zetons = currencyToZetons(amount, 'leos')
  const zetonsFormatted = currencyFormat(zetons)

  return withSymbol
    ? `${zetonsFormatted} ${currenciesSymbols.zetons}`
    : zetonsFormatted
}
